function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35z",
  fill: "#68B7E6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.948 45.188H40.6a.583.583 0 00-.485.258l-1.195 1.773h-7.444l-1.195-1.773a.585.585 0 00-.485-.258H12.45a.584.584 0 00-.584.584v2.692a3.846 3.846 0 004.003 3.657h38.66a3.847 3.847 0 004.004-3.657v-2.692a.585.585 0 00-.584-.584zm-.584 3.276a2.682 2.682 0 01-2.835 2.49h-38.66a2.682 2.682 0 01-2.836-2.49v-2.108h16.454l1.195 1.773a.584.584 0 00.485.259h8.064a.583.583 0 00.485-.259l1.195-1.773h16.453v2.108zM14.632 44.25a.584.584 0 00.583-.582V20.054A.786.786 0 0116 19.27h38.399a.785.785 0 01.784.784v23.614a.584.584 0 001.167 0V20.054a1.954 1.954 0 00-1.951-1.951H15.999a1.954 1.954 0 00-1.951 1.951v23.614a.584.584 0 00.584.583z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.634 33.306H21.93a.581.581 0 00-.584.583v7.703a.583.583 0 00.584.583h7.703a.583.583 0 00.583-.583v-7.703a.583.583 0 00-.583-.583zm-.584 7.703h-6.533v-6.534h6.533v6.534zM30.216 26.988a.584.584 0 10-1.167 0v2.868h-6.534v-6.534h5.262a.584.584 0 000-1.167h-5.845a.582.582 0 00-.584.583v7.703a.584.584 0 00.584.584h7.703a.584.584 0 00.583-.584l-.002-3.453z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.633 22.787a.584.584 0 00-.826 0l-3.927 3.928-1.258-1.258a.584.584 0 00-.826.826l1.67 1.67a.583.583 0 00.826 0l4.341-4.34a.585.585 0 000-.826zM48.757 24.09h-13.73a.584.584 0 000 1.167h13.73a.583.583 0 100-1.167zM35.03 29.087h8.78a.584.584 0 100-1.168h-8.78a.584.584 0 000 1.168zM49.344 35.822a.584.584 0 00-.583-.584H35.03a.584.584 0 000 1.168h13.726a.584.584 0 00.587-.584zM35.03 39.068a.584.584 0 100 1.168h8.78a.584.584 0 000-1.168h-8.78z",
  fill: "#fff"
});

var SvgIconSentaku2Blue = function SvgIconSentaku2Blue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgIconSentaku2Blue;